module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "zhlzh-page"
    }
  }, [_c('div', {
    staticClass: "china-top",
    style: ({
      background: ("url(" + _vm.chinaTopBg + ")")
    })
  }, [_c('img', {
    attrs: {
      "src": _vm.chinaTopImg,
      "alt": "开心中华老字号",
      "width": "1268",
      "height": "150"
    }
  })]), _vm._v(" "), _c('banner', {
    attrs: {
      "data": _vm.banners
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "china-warpper",
    style: ({
      background: ("url(" + _vm.chinaBg + ")")
    })
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('optimization'), _vm._v(" "), _c('culture', {
    attrs: {
      "data": _vm.youxuanList
    }
  }), _vm._v(" "), _c('influx')], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8482895e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/china-time-honored/index.vue
// module id = 1648
// module chunks = 1